import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { downloadBlob } from '@/_shared/helpers/download';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_EMPLOYEES_IMPORTS_TEMPLATE_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import {
  API_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE,
  KEY_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE,
} from '../constants';
import { MOCK_RESPONSE_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE } from '../mocks';

type RequestDownloadEmployeesImportsTemplate = GenericGet<
  typeof API_EMPLOYEES_IMPORTS_TEMPLATE_PATH_KEY
>['request']['path'];

export type CallParamsGetDownloadEmployeesImportsTemplate =
  RequestDownloadEmployeesImportsTemplate & {
    fileName?: string;
    successSaga?: CallbackSaga;
    errorSaga?: CallbackSaga;
  };

type CallResponseGetDownloadEmployeesImportsTemplate = Blob;

type CallErrorGetDownloadEmployeesImportsTemplate = GenericApiError;

type CallSelectorsGetDownloadEmployeesImportsTemplate = unknown;

let fileName: string | undefined;

export const getDownloadEmployeesImportsTemplateCall = createGeneralCall<
  CallParamsGetDownloadEmployeesImportsTemplate,
  CallResponseGetDownloadEmployeesImportsTemplate,
  CallErrorGetDownloadEmployeesImportsTemplate,
  CallSelectorsGetDownloadEmployeesImportsTemplate
>({
  id: KEY_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE,
  url:
    ({ payload: { fileName: givenFileName = 'employees_imports_template' } }) =>
    () => {
      fileName = givenFileName || undefined;
      return API_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE();
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED()
    ? MOCK_RESPONSE_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE
    : undefined,
  responseExtractor: 'blob',
  responseMapper: ({ response: blob }) => {
    downloadBlob(blob, fileName);
  },
});
